/* ==============================================================================
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
============================================================================== */

import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

// @mui material components
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';

// Material Dashboard 2 PRO React components
import MDBox from 'components/MDBox';
import MDButton from 'components/MDButton';

// Material Dashboard 2 PRO React examples
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import Footer from 'examples/Footer';
import Navbar from 'examples/Navbars/NavBar';
import { APP_STATE } from 'services/Define';
import { FetchData } from 'services/Request';
import * as Func from 'services/Function';

// Component
import RpStock from './RpStock';
import RpWarehouseSale from './RpWarehouseSale';
import RpWarehouseRequest from './RpWarehouseRequest';
import RpExport from './RpExport';
import RpReceive from './RpReceive';
import RpExportMove from './RpExportMove';
import RpExportPoint from './RpExportPoint';
import RpStockBranch from './RpStockBranch';
import RpStockMovement from './RpStockMovement';
import RpExportRequest from './RpExportRequest';
import RpReceiveList from './RpReceiveList';
import RpExportLost from './RpExportLost';
import RpExportInvite from './RpExportInvite';
import RpImportStore from './RpImportStore';
import RpInactive from './RpInactive';
import ReportStockDay from './RpStockDayOnShelf';

function ReportWarehouse() {
  const mod = 'report_warehouse';
  const { t, i18n } = useTranslation();
  const { id } = useParams();
  const app = useSelector((state) => state[APP_STATE]);
  const [menu, setMenu] = useState([]);

  const init = () => {
    FetchData('OPTIONS', `/report/load`, app.token, {
      lang: app.lang,
      code: 'store',
    }).then((result) => {
      if (result.status === 'ok') {
        setMenu(result.data);
      } else {
        Func.exitApp();
      }
    });
  };

  const setBtnBadge = (name, link, key) => {
    return (
      <Grid item xs={12} key={key}>
        <MDButton color='light' href={link} fullWidth>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'left',
              width: '100%',
              gap: 1,
              fontSize: 15,
              fontWeight: 400,
            }}
          >
            {key}. {name}
          </Box>
        </MDButton>
      </Grid>
    );
  };

  const renderButton = () => {
    return (
      <MDBox mb={7}>
        <Card sx={{ p: 2 }}>
          <Grid container spacing={1}>
            {menu.map((item, i) =>
              setBtnBadge(t(`menu.${item.code}`), `/${mod}/${item.code}`, i + 1)
            )}
          </Grid>
        </Card>
      </MDBox>
    );
  };

  const renderReport = () => {
    if (id === 'rp_stock') return <RpStock />;
    if (id === 'rp_stock_branch') return <RpStockBranch />;
    if (id === 'rp_receive') return <RpReceive />;
    if (id === 'rp_receive_list') return <RpReceiveList />;
    if (id === 'rp_export') return <RpExport />;
    if (id === 'rp_export_move') return <RpExportMove />;
    if (id === 'rp_warehouse_sale') return <RpWarehouseSale />;
    if (id === 'rp_warehouse_request') return <RpWarehouseRequest />;
    if (id === 'rp_export_point') return <RpExportPoint />;
    if (id === 'rp_stock_movement') return <RpStockMovement />;
    if (id === 'rp_export_request') return <RpExportRequest />;
    if (id === 'rp_export_lost') return <RpExportLost />;
    if (id === 'rp_export_invite') return <RpExportInvite />;
    if (id === 'rp_import_store') return <RpImportStore />;
    if (id === 'rp_inactive') return <RpInactive />;
    if (id === 'rp_stock_day_on_shelf') return <ReportStockDay />;

    return (
      <MDBox>
        <Navbar route={[t(`menu.report`), t(`menu.report_stock`)]} />
        <MDBox py={3}>{renderButton()}</MDBox>
      </MDBox>
    );
  };

  useEffect(() => {
    i18n.changeLanguage(app.lang);

    if (id === undefined) {
      init();
    }
  }, [id]);

  return (
    <DashboardLayout>
      {renderReport()}
      <Footer />
    </DashboardLayout>
  );
}

export default ReportWarehouse;
